import { Component, OnInit, SecurityContext } from '@angular/core';
import { faCopy, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { AsyncModalService } from 'src/app/services/shared/async-modal-service';
import { DomSanitizer } from '@angular/platform-browser';
import { PlantQRCodeService } from '../../../../services/procurement/plant-qrcode.service';
import html2canvas from 'html2canvas';
import { Globals } from '../../../../app.globals';
import { NavService } from '../../../../services/nav.service';

@Component({
    standalone: false,
    selector: 'app-plant-qrcode-modal',
    templateUrl: './plant-qrcode-modal.component.html',
    styleUrls: ['./plant-qrcode-modal.component.css'],
    providers: [PlantQRCodeService]
})
export class PlantQRCodeModalComponent implements OnInit {
    private qrCodeImageBase64: string;
    faCopyUse: IconDefinition = faCopy;
    canCopy: boolean;
    canDownload: boolean;
    qrCodeImage: any;
    qrCodeFileName: string;
    qrCodeLabel: string;
    clientName: string;

    constructor(
        private qrCodeService: PlantQRCodeService,
        private asyncModalService: AsyncModalService,
        private sanitizer: DomSanitizer,
        private globals: Globals,
        private navService: NavService
    ) {

    }

    ngOnInit(): void {
        this.canCopy = false;
        this.canDownload = false;
    }

    generateQRCode(projectId: number, plantType: string, row: any) {
        let qrCodeName = '';
        let plantItemId = plantType == 'externalplant' ? row.externalPlantItemId : row.id;
        this.qrCodeLabel = '';
        this.clientName = '';

        qrCodeName += row.manufacturer ? row.manufacturer : "";
        qrCodeName += row.modelNo ? " - " + row.modelNo : "";
        qrCodeName += row.assetNo ? " - " + row.assetNo : "";

        this.qrCodeFileName = qrCodeName + ".jpeg";
        this.qrCodeImage = "/img/QRCode-Loader.gif";

        return new Promise((resolve, reject) => {
            this.qrCodeService.generateQRCode(projectId, plantType, plantItemId)
                .subscribe(
                    (data) => {
                        this.qrCodeImageBase64 = 'data:image/png;base64,' + data;
                        this.qrCodeImage = this.sanitizer.sanitize(
                            SecurityContext.HTML,
                            this.sanitizer.bypassSecurityTrustHtml(this.qrCodeImageBase64)
                        );

                        this.qrCodeLabel = qrCodeName;
                        this.clientName = this.navService.menu.client.name != null ? this.navService.menu.client.name : ""
                        this.canCopy = true;
                        this.canDownload = true;
                        return resolve(true);
                    },
                    (err) => {
                        this.asyncModalService.getModalResponse(err.error);
                        return reject(false);
                    }
                );
        });
    }

    download() {
        let globals = this.globals;
        try {
            globals.showSpinner();
            let qrCodeFileName = this.qrCodeFileName;
            let divQRCodeImage = document.getElementById('divQRCodeImage');
            html2canvas(divQRCodeImage).then((canvas) => {
                let generatedImage = canvas.toDataURL('image/jpeg');
                let a = document.createElement('a');
                a.href = generatedImage;
                a.download = qrCodeFileName;
                globals.hideSpinner();
                a.click();
            });
        }
        catch {
            globals.hideSpinner();
            this.asyncModalService.getModalResponse("Failed to Download QR Code");
        }
    }

    copy() {
        let el = document.createElement("img");
        el.src = this.qrCodeImageBase64
        document.body.appendChild(el);
        document.execCommand("copy");
        document.body.removeChild(el);

        this.asyncModalService.getModalResponse("Link copied to clipboard");
    }

    close() {
        this.canDownload = false;
    }


    private convertBase64ToBlobData(imageData: string, contentType: string = 'image/png', sliceSize = 512) {
        const byteCharacters = atob(imageData.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
